module.exports = __webpack_public_path__ + "static/media/exitFullscreen.63ddeae1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/organisms/KidsTour/exitFullscreen.svg
// module id = 925
// module chunks = 0